// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__+ssYH","rotation":"styles_rotation__+Uh8h"};